module.exports = __webpack_public_path__ + "img/Confectioning.0632b9d1.png";